module.exports = __webpack_public_path__ + "img/lasource-37.3fc4fd97.jpg";